//Get
import { Language } from "../services/api";

export class LoadVisibilities
{
    static readonly type = '[App] Load App Visibilities';
}

export class LoadLanguages
{
    static readonly type = '[App] Load App Languages';
}

export class LoadAllLanguages
{
    static readonly type = '[App] Load App All Languages';
}

export class LoadTags
{
    static readonly type = '[App] Load App Tags';
}

export class GetTagNames
{
    static readonly type = '[App] Get App Tag Names';
}

export class LoadApiVersion
{
    static readonly type = '[App] Load App ApiVersion';
}

export class LoadProductTypes
{
    static readonly type = '[App] Load App ProductTypes';
}

export class LoadVersionTypes
{
    static readonly type = '[App] Load App VersionTypes';
}

export class LoadNoteTypes
{
    static readonly type = '[App] Load App NoteTypes';
}

export class LoadUserSubscriptions
{
    static readonly type = '[App] Load App Subscriptions User';
}

export class LoadLogs
{
    static readonly type = '[App] Load App Logs';

    constructor(public startDate?: Date, public endDate?: Date) { }
}

export class LoadLogsOverview
{
    static readonly type = '[App] Load App Logs Overview';
}

//Other
export class FilterLogsText
{
    static readonly type = '[App] Filter Logs Text';

    constructor(public filterValue: string) { }
}

export class FilterLogsType
{
    static readonly type = '[App] Filter Logs Type';

    constructor(public filter: boolean) { }
}

export class ChangeLanguage
{
    static readonly type = '[App] Change Language';

    constructor(public lang: Language) { }
}

export class ChangeProductView
{
    static readonly type = '[App] Change View';

    constructor(public view: string) { }
}



